import React, { Component } from 'react';
import { withFirebase } from '../Fb';
import { Typography } from '@mui/material';
import { Row, Col } from 'reactstrap';

class ActivityDetails2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      activity: this.props.activity,
    };
  }

  componentDidMount() {
    if (this.state.activity) {
      console.log('this.state.activity is not null')
      return
    }
    this.setState({ activity: this.props.activity, loading: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activity !== this.props.activity) {
      this.setState({ activity: this.props.activity, loading: false });
    }
    // if (!prevProps.activity && this.props.activity) {
    //   console.log('prevProps.activity is null')
    //   this.setState({ activity: this.props.activity, loading: false })
    // } else if (this.props.activity && prevProps.activity && this.props.activity.id !== prevProps.activity.id) {
    //   console.log('prevProps.activity.id is not equal to this.props.activity.id')
    //   this.setState({ activity: this.props.activity, loading: false });
    // }
  }

  componentWillUnmount() {
    // Nothing to do. This used to setState({ activity: null }) on the way out, which is a
    // no-op on an unmounting component at best and left the render dereferencing null at
    // worst - the Details view crashed the whole page with "Cannot read properties of null
    // (reading 'name')".
  }


  render() {
    const a = this.state.activity
    // Guarded because the activity can legitimately be absent for a render or two, and
    // a.name.fi took the entire admin page down with it.
    if (!a || !a.name) return null
    return (
      <div style={{ padding: 20, backgroundColor: 'white' }}>
        <Row>
          <Col>
            <Typography variant='h4' gutterBottom>
              {a.name.fi}
            </Typography>
          </Col>
        </Row>
      </div>
    )
  }
}

export default withFirebase(ActivityDetails2)
